import { render } from "./UserManagement.vue?vue&type=template&id=45ff46a9&scoped=true&ts=true"
import script from "./UserManagement.ts?vue&type=script&lang=ts"
export * from "./UserManagement.ts?vue&type=script&lang=ts"

import "./UserManagement.scss?vue&type=style&index=0&id=45ff46a9&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff46a9"]])

export default __exports__